import { toRefs } from 'vue';
import { getKeycloak } from './keycloak';
import { state } from './state';
import { isNil } from './utils';
export const useKeycloak = () => {
    return Object.assign(Object.assign({}, toRefs(state)), { keycloak: getKeycloak(), hasRoles: (roles) => !isNil(roles) && state.isAuthenticated && roles.every(role => state.roles.includes(role)) });
};
//# sourceMappingURL=composable.js.map